import { render, staticRenderFns } from "./AddUsersToTasksModal.vue?vue&type=template&id=3673a71e&scoped=true&"
import script from "./AddUsersToTasksModal.vue?vue&type=script&lang=js&"
export * from "./AddUsersToTasksModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3673a71e",
  null
  
)

export default component.exports